export const COMMENT_TYPES = [
  { icon: 'RADIO', title: 'Radio Buttons' },
  { icon: 'CHOICES', title: 'Multiple Choices' },
  { icon: 'DATE', title: 'Date' },
  { icon: 'NUMBER', title: 'Number' },
  { icon: 'RANGE', title: 'Numeric Range' },
  { icon: 'TEXT', title: 'Text' },
];
